
<template>


    <v-container>
    
 
  <v-row style="font-size: 22px; color:darkorange">
<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;使用者權限管理
</v-row>

        
        <!--v-combobox
        v-model="areaId"
        label="存取區域"
        :items="itemAreas"
        item-title="text"
        item-value="value"
        variant="solo"
        class="pa-1"
        style="width: 300px;"
        return-object
    ></v-combobox>
        <v-combobox
                v-model="controlId"
                label="控制項目"
                :items="itemControls"
                item-title="text"
                item-value="value"
                style="width: 300px;"
                
              ></v-combobox>
        <v-btn 
                @click="fetchData" 
                class="load-button"
                color="#5865f2"
                size="medium"
                variant="flat" >載入表格及資料
        </v-btn>
        <br/-->
        <br/>
      <v-data-table
        :headers="headers"
        :items="items"
        item-key="userId"
        class="elevation-1"
        height="350"
        fixed-header
        items-per-page-text="每頁顯示筆數"
        no-data-text="無資料"
        loading-text="載入中"
        :pageText="'{0}-{1} 之 {2}'"
        @click:row="(item,row) => rowClick(item,row)" 
        :item-class="() => 'getRowClass'"
        items-per-page="5"
        single-select
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>使用者存取權限管理</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="600px">
              <template v-slot:activator="{ props }">
                <v-btn color="primary" dark class="mb-2" v-bind="props">
                  新增
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col
                        v-for="(header, index) in headers"
                        :key="index"
                        cols="12"
                        sm="6"
                        md="4"
                      >
                      
                        <v-text-field 
                          v-model="editedItem[header.key]"
                          :label="header.title"
                          v-if="header.type==0 && header.key !== 'actions'"
                        ></v-text-field>
                        <v-combobox
                        v-if="header.key === 'areas'"
                        v-model="editedItem.selectedAreas"
                        :label="header.title"
                        :items="itemAreas"
                        item-title="areaName"
                        item-value="areaId"
                        multiple
                        chips
                      ></v-combobox>
                      <v-combobox
                        v-if="header.key === 'controls'"
                        v-model="editedItem.selectedControls"
                        :label="header.title"
                        :items="itemControls"
                        item-title="controlName"
                        item-value="controlId"
                        multiple
                        chips
                      ></v-combobox>
                       
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeDialog">
                    取消
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="save">
                    儲存
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
        <template v-slot:[`item.areas`]="{ item }">
        <span>
          {{ item.selectedAreas.map(area => area.areaName).join(', ') }}
        </span>
      </template>
      <template v-slot:[`item.controls`]="{ item }">
        <span>
          {{ item.selectedControls.map(control => control.controlName).join(', ') }}
        </span>
      </template>
      </v-data-table>
    </v-container>
  </template>
  
  <script>
  import axios from 'axios';
  import {reactive, toRefs,onBeforeMount,onMounted,ref,watch} from 'vue'
  import vuetify from '../plugins/vuetify';
  const env = import.meta.env;
  const apiUrl = window.config.API_URL; //(env.VITE_APP_API_ENDPOINT);
  

  export default {
    mounted() {
      //this.fetchFormFields(); 
      //this.loadPreData();
      this.loadPreData();
      
    },
    data() {
        console.log('api url',this.$config.API_URL);
      return {
        apiUrl: this.$config.API_URL,
        userId:null,
        userName:null,
        control:null,
        dialog: false,
        itemAreas:[],
        itemControls:[],
        selectedRows: [],
        headers: [
          { title: '使用者代碼', key: 'userId', type:0 },
          { title: '使用者名稱', key: 'userName', type:0},
          { title: '存取區域', key: 'areas' ,type:1},
          { title: '存取項目', key: 'controls' ,type:1},
          { title: '編輯/刪除', key: 'actions', type:-1, sortable: false }
          //{ title: 'PHONE', key: 'phone' },
          //{ title: 'Actions', key: 'actions', sortable: false }
        ],
        items: [],
        editedIndex: -1,
        editedItem: {
          userId: '',
          userName: '',
          areaIds: [],
          controlIds:[],
          selectedAreas:[],
          selectedControls:[],
        },
        defaultItem: {
          userId: '',
          userName: '',
          areaIds: [],
          controlIds:[],
          selectedAreas:[],
          selectedControls:[],
        },
        
      };
    },
    
   
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? '新增項目' : '編輯項目';
      }
    },
    watch: {
      dialog(val) {
        val || this.closeDialog();
      }
    },
    methods: {
        getSelectedValue(key)
        {
          //alert(key);
          console.log('key 0',key);
          switch(key) {
            case 'areas':
              console.log('selected A',this.item.areasDisplay);
            return this.item.areasDisplay;
            case 'controls':
            console.log('selected C',this.item.controlsDisplay);
            return this.item.controlsDisplay;
            default:
            return [];
        }
        },
        getComboboxOptions(key) {
          //alert('1');
            console.log('key 1',key);
        switch(key) {
            case 'areas':
                console.log(this.itemAreas);
            return this.itemAreas;
            case 'controls':
            console.log(this.itemControls);
            return this.itemControls;
            default:
            return [];
        }
        },
        getItemTitle(key) {
            switch(key) {
                case 'areas':
                return 'areaName';
                case 'controls':
                return 'controlName';
                default:
                return '';
            }
            },
        getItemValue(key) {
            switch(key) {
                case 'areas':
                return 'areaId';
                case 'controls':
                return 'controlId';
                default:
                return '';
            }
        },
        async loadPreData()
        {
            try {
                
                
                console.log('api:'+ `${apiUrl}/item/getaccessitems`);
                const response = await axios.get(`${apiUrl}/item/getaccessitems`);
                console.log(response);
                console.log(response.data);
                this.itemAreas = response.data.lstAreas ;
                this.itemControls = response.data.lstControls;
                
                console.log('itemAreas', this.itemAreas);
                //console.log(this.itemControls);
                //console.log(this.itemControls);
                //let d=new Date();
                //d.setHours(d.getHours() + 8);
                //this.formData['formDate']=d.toISOString().substr(0, 10);

                this.fetchData();

            } catch (error) {
                console.error('載入站台及類型錯誤:', error);
                alert('載入資料錯誤:'+ error);
            }
        },
        async loadFormAndData()
        {
            try
            {

            }
            catch(e)
            {
                
            }
        },
      async fetchData() {
        try {
            console.log('call fetchData',`${apiUrl}/item/getUserItems`);
          const response = await axios.get(`${apiUrl}/item/getUserItems`)
          .then(response => {
    console.log('Response Data:', response.data); // Log the entire response data

    this.items = response.data.map(user => {
        console.log(user.areaIds);
      const areaIds = user.areaIds ? user.areaIds.split(',') : '';
      const controlIds = user.controlIds ? user.controlIds.split(',') : '';

      console.log('User:', user);
      console.log('AreaIds:', areaIds);
      console.log('ControlIds:', controlIds);

      var selected=areaIds;
      console.log('selected ',selected);
      const selectedAreas = this.itemAreas.filter(area => areaIds.includes(area.areaId));

      const selectedControls = this.itemControls.filter(control => controlIds.includes(control.controlId));
      return {
        ...user,
       
        selectedAreas,
        selectedControls,
      };
    });
  })
  .catch(error => {
    console.error('Error fetching data:', error);
  });


        } catch (error) {
          console.error(error);
        }
      },
      editItem(item) {
        this.editedIndex = this.items.indexOf(item);
        this.editedItem = {
          ...item,
          selectedAreas: item.selectedAreas,  // Keep previously selected areas
          selectedControls: item.selectedControls // Keep previously selected controls
        };
        this.dialog = true;
      },
      async deleteItem(item) {
        const index = this.items.indexOf(item);
        if (confirm('確認刪除['+item.userName+'] 使用者?')) {
          try {
            //const response= await axios.delete(`${apiUrl}/api/forms/deleteitem?station=${this.stationName.value}&Control=${this.Control.value}&itemname=${item.itemName}&seq=${item.seq}`);
            console.log("userId:",item.userId);
            const response= await axios.delete(`${apiUrl}/item/delete?userid=${item.userId}`);
            if (response.status===200)
            {
              this.items.splice(index, 1);
            }
          } catch (error) {
            console.error(error);
          }
        }
      },
      closeDialog() {
        this.dialog = false;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      },
      async save() {
        try {
            console.log('editIndex',this.editedIndex);
            
          if (this.editedIndex > -1) {
            console.log(this.editedItem.selectedAreas);
            console.log(this.editedItem.selectedControls);
            const payload = {
            userId: this.editedItem.userId,
            userName: this.editedItem.userName,
            // Convert selected areas to comma-separated IDs
            
            areaIds: this.editedItem.selectedAreas
            .map(area => area.areaId)
            .join(','),
            controlIds:this.editedItem.selectedControls
            .map(control => control.controlId)
            .join(','),
            /*
            areaIds: this.editedItem.areas
                .map(area => area.areaId)
                .join(','),
            
            controlIds: this.editedItem.controls
                .map(control => control.controlId)
                .join(','),
            */
            };
            console.log(`${apiUrl}/item/save/${payload.userId,payload.areaIds}`);
            const response=await axios.post(`${apiUrl}/item/edit`,payload);
            if (response.status==200)
              Object.assign(this.items[this.editedIndex], this.editedItem);
          } else {
            
            const payload = {
            userId: this.editedItem.userId,
            userName: this.editedItem.userName,
            areaIds: this.editedItem.selectedAreas
            .map(area => area.areaId)
            .join(','),
            controlIds:this.editedItem.selectedControls
            .map(control => control.controlId)
            .join(','),
            };
            //console.log(`${apiUrl}/item/add/${payload.areaIds}`);

            const response = await axios.post(`${apiUrl}/item/add`,payload);
            console.log('adderd',response.data);
            
            const user = response.data; 
            console.log(user.areaIds); 
            const areaIds = user.areaIds ? user.areaIds.split(',') : ''; 
            const controlIds = user.controlIds ? user.controlIds.split(',') : ''; 
            console.log('User:', user); 
            console.log('AreaIds:', areaIds); 
            console.log('ControlIds:', controlIds); 
            const selectedAreas = this.itemAreas.filter(area => areaIds.includes(area.areaId)); 
            const selectedControls = this.itemControls.filter(control => controlIds.includes(control.controlId)); 
            const newUser = { 
              ...user, 
              selectedAreas, 
              selectedControls, 
            }; 
            console.log('New User:', newUser);
    
            this.items.push(newUser);
            //this.items = [...this.items, response.data];
          }
          this.closeDialog();
        } catch (error) {
          console.error(error);
        }
      },
      getRowClass(item) {
        console.log('getRowClass');
        console.log('item',item);
        return this.selectedRows.includes(item.id) ? 'selected-row' : '';
      },
      rowClick: function (item, row ) {      
        console.log('row',row);
        //console.log('item',item.value);
        //return;
        const id = row.item.itemName // just temporary
        console.log('item',row.item.itemName);
        const rowNo = this.selectedRows.indexOf(id)
        if(rowNo == -1) {
          this.selectedRows.push(id)
          //row.select(true);
        } else {
          this.selectedRows.splice(rowNo, 1)
          ///row.select(false);
        }
        console.log(this.selectedRows)
      },
      log: function (event) {      
        console.log(event)
      }
    },
    created() {
      //this.fetchData();
    }
  };
  </script>
  
  <style scoped>
  .label-container {
    display: inline-block;
    margin-left: 15px;
    vertical-align: top;
  }
  
  .field-container {
    display: inline-flex;
    flex-wrap: wrap;
    margin-left: 10px;
  }
  
  .text-field-wrapper {
    flex: 1;
    min-width: 100px;
    margin-right: 10px;
  }
  
  @media (max-width: 600px) {
    .text-field-wrapper {
      flex: 0 1 45%;
      margin-bottom: 10px;
    }
  }
  .selected-row {
  background-color: #e0f7fa; /* Change to your desired color */
}
tr.v-data-table__selected {
  background: #7d92f5 !important;
}
  </style>
  